<ng-container *transloco="let t">
	<a
		routerLink="/profile"
		[title]="t('UI.visit_profile')"
		class="ml-4 flex h-8 w-8 appearance-none items-end justify-center overflow-hidden rounded-full bg-gray-400 text-3xl text-gray-650"
	>
		@if (imageUrl) {
			<img
				class="h-8 w-8 rounded-full object-cover object-center"
				alt="User"
				[src]="imageUrl ? imageUrl : './assets/images/placeholder/fallback.jpg'"
				onerror="this.src = './assets/images/placeholder/fallback.jpg'"
			/>
		} @else {
			<fa-icon class="-mb-2" [icon]="faUser"></fa-icon>
		}
	</a>
</ng-container>
